module.exports = __webpack_public_path__ + "static/media/on-eye_classic-SheerDream.8cec24b8.jpg";